import { Grid, Typography } from '@mui/material';
import { Column, Row } from '../../../../../../components';
import { Svgs } from '../../../../../../assets/svg';
import { t } from 'i18next';

const MobileChecklist: React.FC = () => {
  const svgStyle = { marginRight: '10px', minWidth: '30px', maxWidth: '30px' };
  return (
    <Grid
      style={{
        display: 'flex',
        flexDirection: 'column',
        margin: '30px 0',
        alignItems: 'center',
      }}>
      <Column
        sx={{
          gap: '10px',
          textAlign: 'left',
        }}>
        <Row>
          <Svgs.DisplaySmallCustomCheckmarkFilled style={svgStyle} />
          <Typography variant='p16' color='secondary'>
            {t('UnlockFundRecommendations')}
          </Typography>
        </Row>
        <Row>
          <Svgs.DisplaySmallCustomCheckmarkFilled style={svgStyle} />
          <Typography variant='p16' color='secondary'>
            {t('PersonalizedAdviceOnAllAccounts')}
          </Typography>
        </Row>
        <Row>
          <Svgs.DisplaySmallCustomCheckmarkFilled style={svgStyle} />
          <Typography variant='p16' color='secondary'>
            {t('FlatFeeNoMatterYourBalance')}
          </Typography>
        </Row>
      </Column>
    </Grid>
  );
};

export default MobileChecklist;
